import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const getCanvasProperties = pageNumber => {
  const _global$document$getE = global.document.getElementsByClassName("pdfpage-".concat(pageNumber)),
    _global$document$getE2 = _slicedToArray(_global$document$getE, 1),
    pageElement = _global$document$getE2[0];
  return pageElement ? {
    scale: pageElement['data-scale'],
    offset: pageElement['data-origin'],
    pdfPageHeight: pageElement['data-pdf-page-height'],
    pageHeight: pageElement.height,
    pageWidth: pageElement.width,
    // increasing the pixel density to match device pixelRatio is nice, but causes unnesseary
    // slow down when rendering, was formerly: "global.window.devicePixelRatio || 1"
    dpiScale: 1,
    pageElement
  } : null;
};
export default {
  getCanvasProperties
};